<template>
  <div class="StaffManage-list">
    <div class="top_buutom">
      <p>
        <span> +{{ isDetail ? "签署任务详情" : "创建签署任务" }}</span>
        <el-tag
          v-if="isDetail"
          style="border-radius:15px;margin-left:10px"
          type="primary"
          size="mini"
          plain
          >{{ handleSignTaskStatus(this.signTaskStatus) }}</el-tag
        >
      </p>
      <el-button
        v-loading.fullscreen.lock="fullscreenLoading"
        v-if="!isDetail"
        @click="sureActivy"
        type="primary"
        >确定创建</el-button
      >
      <template v-else>
        <span
          v-if="this.signTaskStatus === 'finish_creation'"
          style="color:#0981FF;"
          >审批请前往法大大官网操作</span
        >
        <!-- <el-button
          v-else-if="
            this.signTaskStatus === 'task_created'"
          type="primary"
          :disabled="isFieldRequire"
          @click="sureSign"
          >提交签署</el-button
        > -->
      </template>
    </div>
    <!-- <template v-if="isDetail && this.signTaskStatus === 'task_created'">
      <div
        class="top_title_dg"
        style="background-color: #e4ecfd;"
        v-if="!isFieldRequire"
      >
        <i
          style="color:rgb(9, 129, 255);font-size:20px;"
          class="el-icon-success"
        ></i>
        <span>待填写内容已全部填写完成，可再次编辑</span>
        <el-button
          style="margin-left:10px"
          type="primary"
          size="mini"
          plain
          @click="toFillOut"
          >编辑</el-button
        >
      </div>
      <div class="top_title_dg" v-else>
        <i style="color:red;font-size:20px;" class="el-icon-warning-outline"></i>
        <span>当前有待填写控件未完成填写，请先填写完成再提交签署</span>
        <el-button
          style="margin-left:10px"
          type="danger"
          size="mini"
          plain
          @click="toFillOut"
          >去填写</el-button
        >
      </div>
    </template> -->
    <div class="sigincontentscss">
      <div class="sc_hader">基础信息</div>
      <div class="temp_acti">
        <span>使用模板：</span>
        <span style="color: #0981ff; margin-right: 20px">{{
          signTemplateName
        }}</span>
        <el-button
          v-if="!isDetail"
          size="mini"
          type="primary"
          @click="updateTemplate"
          plain
          >更换</el-button
        >
      </div>
      <div class="temp_acti">
        <span style="margin-right: 20px"
          ><span style="color: red">*</span>任务主题</span
        >
        <div style="flex: 1;">
          <el-input
            clearable
            :disabled="isDetail"
            size="small"
            v-model="signTaskSubject"
            maxlength="50"
            placeholder="请输入任务主题，最多50字"
          ></el-input>
        </div>
      </div>
      <div class="dis_al_spbteewn">
        <div class="temp_acti">
          <span style="margin-right: 20px"
            ><span style="color: red">*</span>发起方</span
          >
          <div>
            <el-input
              disabled
              clearable
              v-model="initiatorName"
              size="small"
              maxlength="50"
              placeholder="请输入发起方"
            ></el-input>
          </div>
        </div>
        <div class="temp_acti">
          <span style="margin-right: 20px"
            ><span style="color: red">*</span>签署截止时间</span
          >
          <div>
            <el-date-picker
              v-model="expiresTime"
              type="datetime"
              size="small"
              :disabled="isDetail || effectiveDuration"
              :picker-options="expiresOptions"
              clearable
              placeholder="选择日期时间"
              default-time="23:59:59"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="temp_acti">
          <span style="margin-right: 20px"
            ><span style="color: red">*</span>合同到期时间</span
          >
          <div>
            <el-date-picker
              v-model="dueDate"
              size="small"
              :disabled="isDetail"
              type="date"
              clearable
               :default-value="sixtyDaysLatercd"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              :placeholder="isDetail ? '未设置' : '选择日期'"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="temp_acti">
          <span style="margin-right: 20px"
            ><span style="color: red">*</span>定稿方式</span
          >
          <div>
            <el-radio-group v-model="fillFinalizeType" disabled>
              <el-radio label="00">自动定稿</el-radio>
              <el-radio label="01">手动定稿</el-radio>
              <el-radio label="02">定稿审批</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
    </div>
    <div class="sigincontentscss">
      <div class="sc_hader">合同参与方</div>
      <!-- <div class="sc_centercont">
        <p>
          合同参与方1：信誉楼百货集团有限公司（默认发起方，信息不可修改）
        </p>
      </div> -->
      <div class="sc_centercont" v-for="(item,index) in actors" :key="item.actorId">
        <div class="dis_alin_center">
          <div class="dis_alin_center">
            <span style="margin-right: 5px">{{ item.actorId }}</span>
            <el-tag
              size="mini"
              :type="item.actorType === 'person' ? 'success' : ''"
              >{{
                item.actorType === "corp"
                  ? "企业"
                  : item.actorType === "person"
                  ? "个人"
                  : "--"
              }}</el-tag
            >
          </div>
          <div
            style="margin-left: 400px"
            v-if="(applyType=='02' || (item.actorType === 'person'&&(applyType=='01'||applyType=='00')))&& !item.isInitiator"
          >
            启用身份校验：<span v-if="isDetail">{{ item.isIdentCheck ? "已启用" : "未启用" }}</span>
            <el-switch
              v-else
              style="margin-left: 5px"
              v-model="item.isIdentCheck"
              @change="swtCard(index)"
            ></el-switch>
          </div>
        </div>
        <div
          class="dis_alin_center"
          v-if="
            applyType &&applyType!='02'&&
              !item.isInitiator &&
              item.actorType === 'corp'
          "
        >
          <div class="temp_acti" style="margin: 10px 0">
            <span style="margin-right: 20px"
              ><span style="color: red">*</span>签署商家</span
            >
            <div class="dis_alin_center">
              <div style="width: 350px">
                <el-input
                  v-model="item.fxCorpName"
                  size="small"
                  disabled
                  placeholder="请选择签署商家"
                ></el-input>
              </div>
              <el-tag  v-if="isDetail&&item.fxCorpName" size="small" class="stoandmerch">{{ applyType=='00'?'门店商':'回收商'}}</el-tag>
              <el-button
                v-else
                size="small"
                @click="selectSTOREanDMeant(item, index)"
                type="primary"
                icon="el-icon-plus"
                >选择商户</el-button
              >
            </div>
          </div>
          <div class="temp_acti" style="margin: 10px 40px">
            <span style="margin-right: 20px"
              ><span style="color: red">*</span>指定签署人</span
            >
            <div class="dis_alin_center" v-if="isDetail" style="width: 270px;">
              <el-select
                :disabled="isDetail"
                size="small"
                style="width: 100%;"
                v-model="item.actorCorpStaffId"
                :placeholder="
                  item.fxCorpId ? '请选择指定人员' : '请先选择签署商家'
                "
              >
                <el-option
                  v-for="ele in item.staffList"
                  :key="ele.id"
                  :label="ele.handlerStaffName"
                  :value="ele.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="dis_alin_center" v-else style="width: 270px;">
              <el-select
                :disabled="isDetail"
                size="small"
                v-model="item.actorCorpStaffId"
                :placeholder="
                  item.fxCorpId ? '请选择指定人员' : '请先选择签署商家'
                "
              >
                <el-option
                  v-for="ele in item.staffList"
                  :key="ele.id"
                  :label="ele.handlerStaffName"
                  :value="ele.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="temp_acti">
            启用身份校验：<span v-if="isDetail">{{ item.isIdentCheck ? "已启用" : "未启用" }}</span>
            <el-switch
              v-else
              style="margin-left: 5px"
              v-model="item.isIdentCheck"
              @change="swtCard(index)"
            ></el-switch>
          </div>
        </div>
        <div class="dis_alin_center">
          <div class="temp_acti" style="margin: 10px 0">
            <span style="margin-right: 20px"
              ><span style="color: red">*</span
              >{{ item.actorType === "corp" ? "企业名称" : "姓名" }}</span
            >
            <div style="width: 475px">
              <el-input
                :disabled="isDetail||item.isInitiator"
                v-model="item.actorName"
                size="small"
                clearable
                maxlength="50"
                :placeholder="
                  item.actorType === 'corp' ? '请输入企业名称' : '请输入姓名'
                "
              ></el-input>
            </div>
          </div>
          <div class="temp_acti" style="margin: 10px 40px">
            <span style="margin-right: 20px"
              ><span style="color: red">*</span>手机号/邮箱</span
            >
            <div>
              <el-input
               onkeyup="this.value=this.value.replace(/[\u4E00-\u9FA5]/g,'')"
                :disabled="isDetail"
                v-model="item.accountName"
                size="small"
                clearable
                maxlength="50"
                placeholder="手机号/邮箱"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="dis_alin_center" >
          <div class="temp_acti" v-if="!item.isInitiator" style="margin: 10px 40px 10px 0">
            <span style="margin-right: 20px"
              ><span style="color: red">*</span
              >{{
                item.actorType === "corp" ? "统一社会信用代码" : "身份证号码"
              }}</span
            >
            <div style="width: 434px">
              <el-input
               onkeyup="this.value=this.value.replace(/[^\w_]/g,'')"
                :disabled="isDetail || !item.isIdentCheck"
                v-model="item.certNoForMatch"
                size="small"
                clearable
                :maxlength="item.actorType === 'corp'?'33':'18'"
                :placeholder="
                  item.actorType === 'corp'
                    ? '请输入统一社会信用代码'
                    : '请输入身份证号码'
                "
              ></el-input>
            </div>
          </div>
          <div
            class="temp_acti"
            style="margin: 10px 40px 10px 0px"
            v-if="!item.isInitiator&&item.actorType === 'corp'"
          >
            <span style="margin-right: 20px"
              >法大大实名认证状态：<span>{{
                item.identStatus === true
                  ? "已认证"
                  : item.identStatus === false
                  ? "未认证"
                  : "暂无"
              }}</span></span
            >
            <el-button
              v-if="!isDetail"
              size="mini"
              icon="el-icon-search"
              :loading="searchAuthBtnLoading"
              type="primary"
              @click="searchAuth(index, item)"
              >查询</el-button
            >
          </div>
          <div class="temp_acti" style="margin: 10px 0 10px 0px">
            <span style="margin-right: 20px">参与方式（创建模板时设置）</span>
            <el-checkbox-group v-model="item.permissions" disabled>
              <el-checkbox label="sign">签署</el-checkbox>
              <el-checkbox label="fill">填写</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
    </div>
    <div class="sigincontentscss">
      <div class="sc_hader">合同附件与其他</div>
      <div class="dis_alin_center" style="margin: 10px 0 5px 0">
        <div class="temp_acti">合同附件</div>
        <div v-if="!isDetail&&fddFileUrlList.length<50" style="position: relative; margin: 0 10px 0 20px">
          <el-button icon="el-icon-paperclip" size="small">上传附件</el-button>
          <!-- multiple="multiple" -->
          <input
            v-if="showInput"
            id="FileId"
            class="fa-upload__input"
            type="file"
            accept=".doc, .docx, .wps, .jpg, .jpeg, .png, .pdf, .xls, .xlsx, .zip, .rar, .mp4, .amr, .mp3, .wav"
            @change="handleFileUpload"
          />
        </div>
         <div style="position: relative; margin: 0 10px 0 20px;" v-if="!isDetail&&fddFileUrlList.length>49">
          <el-button icon="el-icon-paperclip" @click="noupfield" size="small">上传附件</el-button>
        </div>
        <p v-if="!isDetail" style="font-size: 14px; color: #999999">
          说明：附件支持,doc, .docx, .wps, jpg, jpeg, .png, .pdf, xls, xlsx,
          .zip, .rar, .mp4..amr,.mp3,.wav 格式，单份附件不超过50MB
        </p>
      </div>
      <div
        v-for="(item, index) in fddFileUrlList"
        :key="index"
        class="dis_al_spbteewn fieldclass"
      >
        <div class="feil_cal dis_al_spbteewn">
          <div class="dis_alin_center">
            <i style="color: #999999" class="el-icon-paperclip"></i>
            <p class="text_flow" style="margin-left: 5px"> {{ item.fileName }}</p>
          </div>
          <span style="color: #999999; font-size: 12px" v-if="item.KBsize"
            >{{ item.KBsize }}KB</span
          >
        </div>
        <i
          v-if="!isDetail && item.fileChannel === '01'"
          style="margin-left: 15px"
          @click="deleetFiled(index)"
          class="el-icon-delete"
        ></i>
      </div>
      <div class="dis_alin_center" style="margin: 10px 0 10px 0">
        <div class="temp_acti">合同抄送</div>
        <div v-if="!isDetail" style="position: relative; margin: 0 10px 0 20px">
          <el-button icon="el-icon-plus" size="small" @click="addEp('person')"
            >抄送个人</el-button
          >
          <el-button icon="el-icon-plus" size="small" @click="addEp('corp')"
            >抄送企业</el-button
          >
        </div>
      </div>
      <div
        class="enterpriseStyle dis_alin_center"
        v-for="item in actorCCs"
        :key="item.actorId"
      >
        <span>{{
          item.actorType == "corp"
            ? "企业"
            : item.actorType == "person"
            ? "个人"
            : "--"
        }}</span>
        <div>
          <el-input
            :disabled="isDetail||(item.channel=='00'&&item.ifGray)"
            size="small"
            clearable
            onkeyup="this.value=this.value.replace(/[^A-Za-z\u4e00-\u9fa5]/g,'')"
            v-model="item.actorName"
            :maxlength="item.actorType == 'corp' ? '50' : '10'"
            :placeholder="
              item.actorType == 'corp'
                ? '请输入企业名称，最多50字'
                : '请输入姓名'
            "
          ></el-input>
        </div>
        <div>
          <el-input
            clearable
            :disabled="isDetail||(item.channel=='00'&&item.ifGray)"
            size="small"
             onkeyup="this.value=this.value.replace(/[\u4E00-\u9FA5]/g,'')"
            v-model="item.accountName"
            placeholder="请输入手机号/邮箱"
          ></el-input>
        </div>
        <i v-if="!isDetail && item.channel=='01'" @click="deleetEp(index)" class="el-icon-delete"></i>
      </div>
    </div>
    <!-- 添加门店商户 -->
    <el-dialog
      title="选择签署商家"
      :visible.sync="companyListDiaShow"
      :close-on-click-modal="false"
      width="1000px"
      top="2%"
      @closed="closeStorediong"
    >
      <el-form :inline="true" :model="bulkPage" class="demo-form-inline">
        <el-form-item label="门店商家">
          <el-select
            size="small"
            v-model="bulkPage.companyId"
            clearable
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in compydataList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            size="small"
            type="primary"
            @click="serchvoluntarilySubmit()"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <div>
        <el-table
          v-loading="companyListDiaLoading"
          border
          ref="multipleTable2"
          :data="createStoreList"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="zdmodelleSelect"
        >
          <el-table-column label="单选" align="center" width="60">
            <template slot-scope="{ row }">
              <div class="add-company">
                <el-radio
                  v-model="currentCompanyId"
                  size="medium"
                  :label="row.id"
                  >空</el-radio
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            type="index"
            align="center"
            label="序号"
            width="70"
            :index="
              (index) => {
                return index + 1 + (bulkPage.pageNum - 1) * bulkPage.pageSize;
              }
            "
          />
          <el-table-column prop="companyName" label="商户名称" align="center">
          </el-table-column>
          <el-table-column prop="contact" label="联系人" align="center">
          </el-table-column>
          <el-table-column prop="phone" label="联系电话" align="center">
          </el-table-column>
          <el-table-column prop="stores" label="门店数量" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.stores || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="stores" label="状态" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.isEnable ? "启用中" : "已禁用" }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="createStoreList.length"
          style="text-align: right; margin: 20px 0"
          background
          @current-change="bulkCurrentChangeDialog"
          :current-page.sync="bulkPage.pageNum"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="bulkPage.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="bulkPage.total"
        >
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click.native="
            companyListDiaShow = false;
            selectedStoreList = [];
          "
          >取消</el-button
        >
        <el-button type="primary" @click.native="companySubmit">确定</el-button>
      </span>
    </el-dialog>
    <!-- 添加回收商列表 -->
    <el-dialog
      title="选择签署商家"
      :visible.sync="addMerchantDiaShow"
      :close-on-click-modal="false"
      width="1000px"
      top="2%"
      @closed="addMerchantDiaClose"
    >
      <el-form :inline="true" :model="diaMerchantForm">
        <el-form-item label="回收商" prop="merchantId">
          <el-select
            size="small"
            v-model="diaMerchantForm.merchantId"
            clearable
            filterable
            placeholder="请输入回收商名称查询"
          >
            <el-option
              v-for="item in merchantList"
              :key="item.merchantId"
              :label="item.merchantName"
              :value="item.merchantId"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            size="small"
            type="primary"
            @click="dialogSearchMerchant(1)"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        v-if="addMerchantDiaShow"
        ref="addMerchantDia"
        :data="dialogTableData"
        v-loading="merchantDiaLoading"
        tooltip-effect="dark"
        border
        style="width: 100%"
        @selection-change="handSelect"
      >
        <el-table-column label="单选" align="center" width="60">
          <template slot-scope="{ row }">
            <div class="add-company">
              <el-radio
                v-model="currentMerchantId"
                size="medium"
                :label="row.merchantId"
                >空</el-radio
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          type="index"
          align="center"
          label="序号"
          width="70"
          :index="
            (index) => {
              return (
                index +
                1 +
                (diaMerchantForm.pageNum - 1) * diaMerchantForm.pageSize
              );
            }
          "
        />
        <el-table-column label="回收商名称" align="center">
          <template slot-scope="{ row }">{{
            row.merchantName || "--"
          }}</template>
        </el-table-column>
        <el-table-column label="联系人" align="center">
          <template slot-scope="{ row }">{{
            row.contactName || "--"
          }}</template>
        </el-table-column>
        <el-table-column label="联系电话" align="center">
          <template slot-scope="{ row }">{{
            row.contactPhone || "--"
          }}</template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.isEnable ? "启用中" : "已禁用" }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="text-align: right; margin-top: 20px"
        @current-change="dialogSearchMerchant"
        :current-page="diaMerchantForm.pageNum"
        layout="total,  prev, pager, next, jumper"
        :total="diaMerchantForm.total"
        :background="true"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click.native="
            addMerchantDiaShow = false;
            selectedMerchantList = [];
          "
          >取消</el-button
        >
        <el-button type="primary" @click.native="addMerchantSubmit"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <!-- 签署模版 -->
    <el-dialog
      title="选择签署模板"
      :visible.sync="signTableShow"
      :close-on-click-modal="false"
      width="1000px"
      top="2%"
    >
      <el-form :inline="true" :model="singnForm">
        <el-form-item label="模版名称" prop="signTemplateName">
          <el-input
            size="small"
            clearable
            v-model="singnForm.signTemplateName"
            placeholder="请输入模版名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="模版状态" prop="signTemplateStatus">
          <el-select
            size="small"
            v-model="singnForm.signTemplateStatus"
            clearable
            multiple
            collapse-tags
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in statusSelectList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            size="small"
            type="primary"
            :loading="searchTemplateBtnLoading"
            @click="dialogSearchSingn(1)"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        v-if="signTableShow"
        ref="singnshDia"
        :data="signTableData"
        v-loading="signDiaLoading"
        tooltip-effect="dark"
        border
        max-height="540"
      >
        <el-table-column
          type="index"
          align="center"
          label="序号"
          width="50"
          :index="
            (index) => {
              return index + 1 + (singnForm.pageNum - 1) * singnForm.pageSize;
            }
          "
        />
        <el-table-column label="模版名称" align="center">
          <template slot-scope="{ row }">{{
            row.signTemplateName || "--"
          }}</template>
        </el-table-column>
        <el-table-column label="模板ID" align="center">
          <template slot-scope="{ row }">{{
            row.signTemplateId || "--"
          }}</template>
        </el-table-column>
        <el-table-column label="创建人" align="center">
          <template slot-scope="{ row }">{{
            row.creatorMemberName || "--"
          }}</template>
        </el-table-column>
        <el-table-column label="最近更新时间" align="center">
          <template slot-scope="{ row }">{{ row.updateTime || "--" }}</template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="{ row }">{{
            handleSignTemplateStatus(row.signTemplateStatus)
          }}</template>
        </el-table-column>
        <el-table-column label="适用商家类型" align="center"> 
          <template slot-scope="{ row }">
            <p>
              {{
                row.applyType === "00"
                  ? "门店商"
                  : row.applyType === "01"
                  ? "回收商"
                  : "暂未设置"
              }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{ row }">
            <el-button type="primary" :disabled="row.signTemplateStatus !== 'valid'" size="small" @click="userTemplet(row)"
              >使用</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="text-align: right; margin-top: 20px"
        @current-change="dialogSearchSingn"
        :current-page="singnForm.pageNum"
        layout="total,  prev, pager, next, jumper"
        :total="singnForm.total"
        :background="true"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="signTableShow = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 创建提示 -->
    <el-dialog
      title="操作提示"
      :visible.sync="addbeforeDialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div>
        <div style="text-align: center">
          有待填写控件未填写，需要先填写完成才可提交签署任务
        </div>
        <div>
          <p>
            待我方处理的必填控件已全部填写完成，提交后我方状态将变更为已填写，不可再修改填写内容，确认提交？
          </p>
          <p style="color: #999999">
            提交后将会预扣 1 份签署用量(首次签署后将正式扣除)
          </p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="turnBeforeOff">稍后再说</el-button>
        <el-button type="primary" @click.native="addBeforSuccess"
          >去填写</el-button
        >
        <el-button type="primary" @click.native="addredySuccess"
          >提交签署</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="操作提示"
      :visible.sync="usedDialogVisible"
      :close-on-click-modal="false"
      width="500px"
      :show-close="false"
    >
      <div>
        <div style="text-align: center" v-if="onIsIdentCheck">
          开启后，姓名/企业名称将作为实名信息进行校验，并且可要求参与方填写的个人证件号或商户的统一社会信用代码
        </div>
        <div style="text-align: center" v-else>
          关闭后，姓名/企业名称将不再作为实名信息进行校验
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="turnSelfeOff">取消</el-button>
        <el-button type="primary" @click.native="usedSuccess">确定</el-button>
      </span>
    </el-dialog>
    <!-- 填写控件内容 -->
    <el-dialog
      title="填写控件内容"
      :visible.sync="controlDialogVisible"
      :close-on-click-modal="false"
      width="850px"
      top="2%"
    >
      <div>
        <p style="color: #ff687b; margin-bottom: 15px">
          以下10个控件内容未绑定参与方，请先填写完成再提交签署
        </p>
        <div
          class="control_content"
          v-for="(item, index) in controlData"
          :key="index"
        >
          <div class="control_num">1</div>
          <div class="con_ctop">
            <p>控件名称：<span style="color: #4c84ff">3合同生效日期</span></p>
            <p>控件编码：<span style="color: #4c84ff">3795689899</span></p>
            <p>控件类型：<span style="color: #4c84ff">单行文本</span></p>
          </div>
          <div class="con_center">
            <span style="margin-right: 8px">请填写</span>``
            <div style="flex: 1">
              <el-input
                v-model="item.fieldValue"
                placeholder="请输入内容"
              ></el-input>
              <el-input
                v-model="item.fieldValue"
                type="textarea"
                placeholder="请输入内容"
              ></el-input>
              <el-input
                v-model="item.fieldValue"
                placeholder="请输入内容"
              ></el-input>
              <el-input
                v-model="item.fieldValue"
                placeholder="请输入内容"
              ></el-input>
              <el-date-picker
                v-model="item.fieldValue"
                type="date"
                placeholder="选择日期"
              ></el-date-picker>
              <el-radio-group v-model="item.fieldValue">
                <el-radio :label="3">备选项</el-radio>
                <el-radio :label="6">备选项</el-radio>
                <el-radio :label="9">备选项</el-radio>
              </el-radio-group>
              <el-checkbox-group
                v-model="item.fieldValue"
                @change="handleCheckedCitiesChange"
              >
                <el-checkbox v-for="city in cities" :label="city" :key="city">{{
                  city
                }}</el-checkbox>
              </el-checkbox-group>
              <el-select v-model="item.fieldValue" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <!-- place-txt="提示：图片仅支持上传jpg/png/gif格式，建议尺寸：340-340px,最多上传3张。" -->
              <ElImgUploadGroup
                :length="1"
                :exist-img-list="item.fieldValue"
                @handleChange="handleUploadGroupChange($event, index)"
              />
              <p style="color: red">
                暂不支持填写表格控件，请前往法大大官网填写
              </p>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="turnControlOff">取消</el-button>
        <el-button type="primary" @click.native="Controluccess">确定</el-button>
      </span>
    </el-dialog>
    <!-- 创建状态提示 -->
    <el-dialog
      title="操作提示"
      :visible.sync="newTitleShow"
      :close-on-click-modal="false"
      width="550px"
    >
      <div style="padding: 40px;">
        <div
          class="dis_alin_center"
          style="justify-content: center;margin-bottom: 15px;"
        >
          <i
            v-if="!errmsg"
            class="el-icon-circle-check"
            style="color: #52c41a;font-size: 30px;margin-right: 5px;"
          ></i>
          <i
            v-else
            class="el-icon-circle-close"
            style="color:red;font-size: 30px;margin-right: 5px;"
          ></i>
          <span style="font-weight: bold;font-size: 20px;">{{
            errmsg ? "任务创建失败" : "任务创建成功"
          }}</span>
        </div>
        <div style="text-align: center;line-height: 20px;">
          <span v-if="!errmsg">请前往任务列表-提交签署</span>
          <span v-else
            >失败原因：<span style="color: red;">{{ errmsg }}</span></span
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="!errmsg">
        <el-button @click.native="newTitleShow = false">稍后再说</el-button>
        <el-button type="primary" @click.native="newSuccess">去签署</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="操作提示"
      :visible.sync="signDialogShow"
      :close-on-click-modal="false"
      width="500px"
      :show-close="false"
    >
      <div v-loading="signDialogLoading" style="padding: 20px 0;">
        <p style="color: #333333;margin-bottom: 5px;">待我方处理的必填控件已全部填写完成，提交后我方状态将变更为已填写，不可再修改填写内容，确认提交？</p>
        <p>提交后将会预扣 1 份签署用量(首次签署后将正式扣除)</p>
      </div>
      <span slot="footer" class="dialog-footer" v-if="!signDialogLoading">
        <el-button @click.native="signDialogShow = false">取消</el-button>
        <el-button type="primary" :loading="signDialogBtnLoading" @click.native="signDialogSubmit">确定</el-button>
      </span>
    </el-dialog>
    <ControlDia
      v-if="controlDiaShow"
      :dialogVisible="controlDiaShow"
      :row="currentRow"
      :docs="currentDocs"
      :fillFields="fillFields"
      @close="controlDiaShow = false"
      @setSuccess="controlSuccess"
    />
  </div>
</template>

<script>
import environments from "@/config/url";
import { encryptByDES } from "@/utils/3DES";
const uploadUrl = environments[process.env.VUE_APP_BASE_URL].fddUploadBaseUrl;
import _api from "@/utils/request";
import { _http } from "@/utils/request/evisaManagement";
import axios from "axios";
import ElImgUploadGroup from "@/components/global/components/elements/upload-group-element";
import moment from "moment";
import ControlDia from "../signatureTask/dialog/ControlDia.vue";
export default {
  components: {
    ElImgUploadGroup,
    ControlDia,
  },
  data() {
    return {
      isFieldRequire: false,
      controlDiaShow: false,
      currentDocs: [],
      fillFields: [],
      currentRow: {
        id: "",
      },
      errmsg: "",
      newTitleShow: false,
      isDetail: true, //是否详情
      signTemplateId: "",
      applyType: "",
      signTemplateName: "",
      signTaskSubject: "",
      expiresTime: "",
      effectiveDuration: null,
      dueDate: "",
      fillFinalizeType: "",
      actors: [],
      actorCCs: [],
      showInput: true,
      headers: {
        ACCESS_TOKEN: localStorage.getItem("token"),
        channel: "platformPc",
        TOKEN: "",
      },
      checkedCities: [],
      plopleoptions: [
        {
          value: "选项1",
          label: "黄金糕",
        },
      ],
      input: "",
      currentCompanyId: "",
      currentMerchantId: "",
      value1: "",
      expiresOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; // 将过去的时间禁用，这里设置为今天之前的时间
        },
        selectableRange:
          new Date().getHours() +
          ":" +
          (new Date().getMinutes() + 1) +
          ":00" +
          " - 23:59:59",
      },
      pickerOptions: {
        disabledDate(time) {
          // 获取当前日期
          const today = new Date();
          // 设置60天后的日期
          const sixtyDaysLater = new Date();
          sixtyDaysLater.setDate(today.getDate() + 60);
          // 返回等于60天后的日期的选项为禁用状态
          return time.getTime() < sixtyDaysLater.getTime();
        },
      },
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
      ],
      cities: ["上海", "北京", "广州", "深圳"],
      controlData: [
        {
          fieldId: "", //编码
          fieldName: "", //名称
          fieldKey: "", //标识
          fieldValue: "", //值
          fieldType: "text_single_line", //类型
        },
      ],
      controlDialogVisible: false,
      addbeforeDialogVisible: false,
      usedDialogVisible: false,
      singnForm: {
        signTemplateName: "",
        signTemplateStatus: [],
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      signTableShow: false,
      companyListDiaShow: false,
      companyListDiaLoading: false,
      selectedStoreList: [],
      createStoreList: [],
      compydataList: [],
      bulkPage: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        companyId: "",
      },
      merchantList: [],
      signDiaLoading: false,
      searchTemplateBtnLoading: false,
      statusSelectList: [
        {
          label: "启用",
          value: "valid",
        },
        {
          label: "停用",
          value: "invalid",
        },
        {
          label: "草稿",
          value: "creating",
        },
      ],
      dialogTableData: [],
      signTableData: [],
      merchantDiaLoading: false,
      diaMerchantForm: {
        merchantId: "",
        pageNum: 1,
        pageSize: 10,
        total: 0,
        merchantType: "02",
      },
      addMerchantDiaShow: false,
      fddFileUrlList: [],
      verificationIndex: "",
      onIsIdentCheck: false,
      templateId: "",
      initiatorName: "",
      searchAuthBtnLoading: false,
      selectActorIndex: null,
      fullscreenLoading: false,
      infoId: "",
      signTaskStatus: "",
      signDialogShow: false,
      signDialogLoading: false,
      signDialogBtnLoading: false,
      signTaskStatusOption: [
        {
          text: "创建中",
          value: "task_created",
        },
        {
          text: "已创建审批中",
          value: "finish_creation",
        },
        {
          text: "填写中",
          value: "fill_progress",
        },
        {
          text: "填写完成",
          value: "fill_completed",
        },
        {
          text: "签署中",
          value: "sign_progress",
        },
        {
          text: "签署完成",
          value: "sign_completed",
        },
        {
          text: "已完成",
          value: "task_finished",
        },
        {
          text: "已逾期",
          value: "expired",
        },
        {
          text: "已撤销",
          value: "cancel",
        },
        {
          text: "已终止",
          value: "task_terminated",
        },
        {
          text: "已作废",
          value: "revoked",
        },
      ],
      sixtyDaysLatercd:null
    };
  },
  created() {
    this.infoId = this.$route.query.id;
    this.currentRow.id = this.$route.query.id;
    if(this.$route.query.source && this.$route.query.source === 'copy'){
      this.isDetail = false
    }
      // 获取当前日期
      const todaycd = new Date();
    // 设置60天后的日期
    this.sixtyDaysLatercd = new Date();
    this.sixtyDaysLatercd.setDate(todaycd.getDate() + 60);
    // let signTemplateId = this.$route.query.id;
    // this.getFadadaTemplateDetail(signTemplateId);
    this.getTaskinfo();
    // this.getFieldRequire();
  },
  mounted() {},
  methods: {
    changeConpy(data,index){
      if (!/^[\u4e00-\u9fa5a-zA-Z]+$/.test(data)) {
        this.actorCCs[index].actorName=''
      } else {
        this.actorCCs[index].actorName=data
      }
    },
    getFieldRequire() {
      _http.getFadadaTaskFieldRequire({ taskId: this.infoId }).then((res) => {
        this.isFieldRequire = res.data.required;
        this.currentDocs = res.data.docs || [];
        this.fillFields = res.data.fillFields || [];
      });
    },
    getTaskinfo() {
      _http.getTaskinfo({ taskId: this.infoId }).then((res) => {
        if (res.code === 1) {
          console.log(res);
          this.signTaskStatus = res.data.signTaskStatus;
          this.templateId = res.data.signTemplateId;
          this.initiatorName = res.data.initiatorName;
          this.signTemplateName = res.data.signTemplateName;
          this.applyType = res.data.corpType;
          if(this.isDetail){
            this.signTaskSubject = res.data.signTaskSubject;
            this.expiresTime = moment(
              res.data.deadlineTime,
              "YYYY-MM-DD HH:mm:ss"
            ).valueOf();
            this.dueDate = res.data.dueDate;
          }
          // moment()
          //   .add(res.data.effectiveDuration, "days")
          //   .format("YYYY-MM-DD") + " 23:59:59";
          this.fillFinalizeType = res.data.finalizeType;
          if (res.data.actors && res.data.actors.length) {
            const actorPromises = res.data.actors.map((item, index) => {
            console.log(item, '+++++++++++++++');
            let staffListPromise = Promise.resolve([]);

            if (res.data.corpType && item.fxCorpId) {
              if (res.data.corpType === '00') {
                staffListPromise = _api.manageStaffSelect({ companyId: item.fxCorpId }).then((comres) => {
                  return comres.data.map((item) => {
                    return { 
                      id: item.staffId, 
                      name: item.staffName ,
                      handlerStaffName:item.handlerStaffName
                    };
                  });
                });
              } else if (res.data.corpType === '01') {
                staffListPromise = _api.recycleStaffSelect({ merchantId: item.fxCorpId, type: "01" }).then((merres) => {
                  return merres.data.map((item) => {
                    return { 
                      id: item.staffId, 
                      name: item.staffName,
                      handlerStaffName:item.handlerStaffName
                    };
                  });
                });
              }
            }

            return staffListPromise.then((staffList) => {
              return {
                isInitiator: item.isInitiator,
                actorId: item.actorId,
                actorType: item.actorType,
                isIdentCheck: item.isIdentCheck,
                fxCorpId: item.fxCorpId,
                fxCorpName: item.fxCorpName,
                actorCorpStaffId: item.actorCorpStaffId,
                certNoForMatch: item.certNoForMatch,
                accountName: item.accountName,
                actorName: item.actorName || "",
                isActorCorpStaff: true,
                identStatus: item.identStatus,
                permissions: item.permissions || [],
                staffList,
              };
            });
          });

          Promise.all(actorPromises).then((actors) => {
            this.actors = actors;
            console.log(this.actors);
          });
          }
          
          if (res.data.actorCCs && res.data.actorCCs.length) {
            this.actorCCs = res.data.actorCCs.map(item=>{
              return {
                ifGray:item.actorName?true:false,
                ...item
              }
            });
          }
          if (res.data.fddFileUrlList && res.data.fddFileUrlList.length) {
            this.fddFileUrlList = res.data.fddFileUrlList
          }
         
        }
      });
    },
    newSuccess() {
      this.newTitleShow = false;
      let routeData = this.$router.resolve({
        path: "/evisaManagement/signatureTask",
        query: {
          taskName: this.signTaskSubject,
        },
      });
      window.open(routeData.href, "_blank");
    },
    handleSignTemplateStatus(val) {
      let statusSelectList = [
        {
          label: "启用",
          value: "valid",
        },
        {
          label: "停用",
          value: "invalid",
        },
        {
          label: "草稿",
          value: "creating",
        },
      ];
      const selectedStatus = statusSelectList.find(
        (item) => item.value === val
      );
      return selectedStatus ? selectedStatus.label : "--";
    },
    // 获取模板详情
    getFadadaTemplateDetail(signTemplateId) {
      _http.getFadadaTemplateDetail({ signTemplateId }).then((res) => {
        if (res.code === 1) {
          this.infoId = ""
          console.log(res);
          this.templateId = res.data.signTemplateId;
          this.initiatorName = res.data.identNameForMatch;
          this.signTemplateName = res.data.signTemplateName;
          this.applyType = res.data.applyType;
          this.effectiveDuration = res.data.effectiveDuration
          this.expiresTime = res.data.effectiveDuration
            ? moment()
                .add(res.data.effectiveDuration, "days")
                .format("YYYY-MM-DD") + " 23:59:59"
            : moment().format("YYYY-MM-DD") + " 23:59:59";
          this.fillFinalizeType = res.data.fillFinalizeType;
          if (res.data.actors && res.data.actors.length) {
            this.actors = res.data.actors.map((item) => {
              return {
                isInitiator: item.isInitiator,
                actorId: item.actorId,
                actorType: item.actorType,
                isIdentCheck: true,
                fxCorpId: "",
                fxCorpName: "",
                actorCorpStaffId: "",
                certNoForMatch: item.certNoForMatch,
                accountName: item.notifyAddress,
                actorName: item.identNameForMatch || "",
                isActorCorpStaff: true,
                identStatus: null,
                permissions: item.permissions || [],
                staffList: [],
              };
            });
          }
          if (res.data.ccs && res.data.ccs.length) {
            this.actorCCs = res.data.ccs.map((item) => {
              return {
                ifGray:item.identNameForMatch?true:false,
                channel: "00", // channel 来源：00：模版自带,01：手动添加
                actorName: item.identNameForMatch || "",
                accountName: item.notifyAddress || "",
                actorType: item.actorType || "",
                actorId: item.actorId || "",
              };
            });
          }
          if (res.data.attachs && res.data.attachs.length) {
            this.fddFileUrlList = res.data.attachs.map((item) => {
              return {
                fileType: "attach",
                fileChannel: "00", // fileChannel 附件来源：00：模版自带,01：手动上传
                fileName: item.attachName || "",
                attachId: new Date().getTime(),
                attachFileId: item.attachId || "",
                attachName: item.attachName || "",
              };
            });
          }
        }
      });
    },
    swtCard(index) {
      this.verificationIndex = index;
      this.onIsIdentCheck = this.actors[this.verificationIndex].isIdentCheck
      this.usedDialogVisible = true;
    },
    turnControlOff() {
      this.controlDialogVisible = true;
    },
    Controluccess() {
      this.controlDialogVisible = true;
    },
    //确定创建
    sureActivy() {
      console.log(
        this.signTaskSubject,
        this.actorCCs,
        this.actors,
        this.fddFileUrlList,
        this.dueDate,
        this.expiresTime,
        this.initiatorName
      );
      if(this.actors.some(item=>!item.accountName)){
        return this.$message.error('合同参与方手机号/邮箱未填写完整！');
      }
      if(this.actors.some(item=>item.isIdentCheck&&!item.certNoForMatch&&!item.isInitiator)){
        return this.$message.error('合同参与方身份证号/统一社会信用代码未填写完整！');
      }
      this.fullscreenLoading = true;
      let params = {
        actorCCs: this.actorCCs,
        actors: this.actors,
        fillFinalizeType: this.fillFinalizeType,
        dueDate: this.transitionTime(this.dueDate.includes(" ") ? this.dueDate : this.dueDate + " " + "23:59:59"), //合同到期日期
        expiresTime: this.transitionTime(this.expiresTime), //签署截止时间
        fddFileUrlList: this.fddFileUrlList,
        initiatorName: this.initiatorName,
        signTaskSubject: this.signTaskSubject,
        signTemplateId: this.templateId,
        signTemplateMame: this.signTemplateName,
        targetTaskId: this.infoId,
      };
      console.log(params);
      _http
        .createTask(params)
        .then((res) => {
          console.log(res);
          if(res.code==1){
            this.errmsg = "";
            this.newTitleShow = true;
            this.fullscreenLoading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          if(err.msg){
            this.errmsg = err.msg||"服务器繁忙，请稍后";
            this.newTitleShow = true;
          }
          this.fullscreenLoading = false;
        });
    },
    transitionTime(time) {
      if (time) {
        let date = new Date(time);
        return date.getTime();
      } else {
        return "";
      }
    },
    //更换模版
    updateTemplate() {
      this.signTableShow = true;
      this.dialogSearchSingn();
    },
    deleetEp(index) {
      this.actorCCs.splice(index, 1);
    },
    addEp(type) {
      this.actorCCs.push({
        channel:'01',
        actorId: new Date().getTime() + "",
        id: new Date().getTime(),
        actorName: "",
        accountName: "",
        actorType: type || "",
      });
    },
    deleetFiled(index) {
      console.log(index);
      this.fddFileUrlList.splice(index, 1);
      // this.fddFileUrlList.forEach((its, index) => {
      //   if (its.id == item.id) {
      //     this.fddFileUrlList.splice(index, 1);
      //   }
      // });
    },
        noupfield(){
      this.$message.error(`只能上传50个附件!`)
    },
    handleFileUpload(event) {
      console.log(event.target.files, uploadUrl);
      const file = event.target.files[0]; // 获取第一个选择的文件
      const isLt2M = file.size / 1024 / 1024 < 50;
      if (!isLt2M) {
        return this.$message.error(`上传文件大小不能超过50MB!`);
      }
      if (file) {
        // 接下来可以调用上传函数等
        this.headers.TOKEN = encryptByDES(
          encryptByDES(
            new Date().getTime().toString(),
            "63e42c2444e94c1ebca21d30d2aa39a5"
          ),
          localStorage.getItem("token") || ""
        );
        this.UploadFied(event.target.files);
      }
    },
    UploadFied(filelist) {
      let uploadList = filelist;
      // 组装文件
      const formData = new FormData();
      formData.append("file", filelist[0]);
      axios
        .post(uploadUrl, formData, {
          headers: this.headers,
        })
        .then((response) => {
          console.log("文件上传成功", response.data.data);
          // uploadList[0].attachId = response.data.data.attachId;
          // uploadList[0].fddFileUrl = response.data.data.fddFileUrl;
          // uploadList[0].fileName = response.data.data.fileName;
          // uploadList[0].fileType = response.data.data.fileType;
          // uploadList[0].fxFileUrl = response.data.data.fxFileUrl;
          // uploadList[0].id = new Date().getTime();
          // uploadList[0].fileChannel = "01"; // fileChannel 附件来源：00：模版自带,01：手动上传
          // uploadList[0].KBsize = (uploadList[0].size / 1024).toFixed(2);
          // uploadList.forEach((item) => {
          //   this.fddFileUrlList.push({
          //     KBsize: item.KBsize,
          //     fileName: item.fileName,
          //     fileChannel: item.fileChannel,
          //     attachFileId: item.attachId,
          //     attachId: item.id,
          //     attachName: item.fileName,
          //     fddFileUrl: item.fddFileUrl,
          //     fileType: item.fileType,
          //     fxFileUrl: item.fxFileUrl,
          //   });
          // });
          let arrobj = {};
          arrobj.KBsize = (uploadList[0].size / 1024).toFixed(2);//转为KB单位
          arrobj.fileName = response.data.data.fileName;
          arrobj.fileChannel = "01";// fileChannel 附件来源：00：模版自带,01：手动上传
          arrobj.attachFileId = response.data.data.attachId;
          arrobj.attachId = new Date().getTime();
          arrobj.id = new Date().getTime();
          arrobj.attachName = response.data.data.fileName;
          arrobj.fddFileUrl = response.data.data.fddFileUrl;
          arrobj.fileType = response.data.data.fileType;
          arrobj.fxFileUrl = response.data.data.fxFileUrl;
          this.fddFileUrlList.push(arrobj);
          console.log(uploadList, "最终", this.fddFileUrlList);
          // 解决浏览器限制文件重复上传
          // document.getElementById('FileId').value = null;只适用于单次上传
          this.showInput = false;
          this.$nextTick(() => {
            this.showInput = true;
          });
        })
        .catch((error) => {
          console.error("文件上传失败", error);
        });

      // uploadList.forEach((item) => {
      //   console.log(item);
      //   // 组装文件
      //   const formData = new FormData();
      //   formData.append("file", item);
      //   axios
      //     .post(uploadUrl, formData, {
      //       headers: this.headers,
      //     })
      //     .then((response) => {
      //       console.log("文件上传成功", response.data);
      //       item.filesValue=response.data.orgUrl
      //       item.KBsize=(item.size / 1024).toFixed(2)
      //     })
      //     .catch((error) => {
      //       console.error("文件上传失败", error);
      //     });
      // });
    },
    selectSTOREanDMeant(item, index) {
      this.selectActorIndex = index;
      if (this.applyType === "00") {
        this.currentCompanyId = item.fxCorpId || "";
        this.getStoreList();
        this.bulkCurrentChangeDialog(1);
        this.companyListDiaShow = true;
      } else {
        this.currentMerchantId = item.fxCorpId || "";
        this.getMerchantList();
        this.dialogSearchMerchant(1);
        this.addMerchantDiaShow = true;
      }
    },
    handleCheckedCitiesChange(e) {
      console.log(e);
    },
    handleUploadGroupChange(list, index) {
      console.log(list, index);
      this.controlData[index].fieldValue = list;
    },
    addredySuccess() {
      this.addbeforeDialogVisible = false;
    },
    turnBeforeOff() {
      this.addbeforeDialogVisible = false;
    },
    addBeforSuccess() {
      this.addbeforeDialogVisible = false;
      this.controlDialogVisible = true;
    },
    turnSelfeOff() {
      this.actors[this.verificationIndex].isIdentCheck = !this.actors[
        this.verificationIndex
      ].isIdentCheck;
      this.usedDialogVisible = false;
    },
    usedSuccess() {
      this.usedDialogVisible = false;
    },
    // 选择签署模板
    dialogSearchSingn(pageNum) {
      this.signDiaLoading = true;
      this.searchTemplateBtnLoading = true;
      _http
        .getFadadaTemplate({
          ...this.singnForm,
          pageNum: pageNum || this.singnForm.pageNum,
        })
        .then((res) => {
          this.signTableData = res.data.records;
          this.singnForm.pageNum = res.data.current;
          this.singnForm.total = res.data.total;
          this.signDiaLoading = false;
        })
        .finally(() => {
          this.searchTemplateBtnLoading = false;
        });
    },
    //跟换模版
    userTemplet(row) {
      this.signTemplateId = row.signTemplateId;
      this.getFadadaTemplateDetail(row.signTemplateId);
      this.signTableShow = false;
    },
    handSelect(selection, row) {
      console.log(selection, row, "selection, rowselection, rowselection, row");
      this.selectedStoreList = selection;
    },
    // 添加商家弹框查询
    dialogSearchMerchant(pageNum) {
      this.merchantDiaLoading = true;
      _api
        .ShopTable({
          ...this.diaMerchantForm,
          pageNum: pageNum || this.diaMerchantForm.pageNum,
        })
        .then((res) => {
          this.dialogTableData = res.data.records;
          this.diaMerchantForm.pageNum = res.data.current;
          this.diaMerchantForm.total = res.data.total;
          this.merchantDiaLoading = false;
        });
    },
    // 添加商家弹框关闭
    addMerchantDiaClose() {
      (this.diaMerchantForm = {
        merchantType: "02",
        merchantId: "",
        pageNum: 1,
        pageSize: 10,
        total: 0,
      }),
        (this.addMerchantDiaShow = false);
      this.selectedStoreList = [];
    },
    getMerchantList() {
      _api.getMerchantSelectList().then((res) => {
        this.merchantList = res.data;
      });
    },
    // 数据请求
    bulkCurrentChangeDialog(val) {
      if (val) {
        this.bulkPage.pageNum = val;
      }
      let params = {
        pageNum: this.bulkPage.pageNum,
        pageSize: this.bulkPage.pageSize,
        companyId: this.bulkPage.companyId,
      };
      this.companyListDiaLoading = true;
      _api.getcompanylist(params).then((res) => {
        console.log(res);
        if (res.code === 1) {
          this.createStoreList = res.data.records;
          this.bulkPage.pageNum = res.data.current;
          this.bulkPage.total = res.data.total;
        }
        this.companyListDiaLoading = false;
      });
    },
    closeStorediong() {
      this.companyListDiaShow = false;
      this.selectedStoreList = [];
      this.bulkPage = {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        companyId: "",
      };
      this.currentCompanyId = "";
    },
    zdmodelleSelect(val) {
      console.log(val);
      this.selectedStoreList = val;
    },
    //搜索
    serchvoluntarilySubmit() {
      console.log(this.bulkPage);
      this.bulkCurrentChangeDialog(1);
    },
    //确定批量选择门店
    companySubmit() {
      if (!this.currentCompanyId) {
        return this.$message.error("请选择门店商家");
      }
      let currentObj = null;
      this.createStoreList.forEach((item) => {
        if (item.id === this.currentCompanyId) {
          currentObj = item;
        }
      });
      if (this.actors[this.selectActorIndex].fxCorpId !== currentObj.id) {
        this.$set(this.actors, this.selectActorIndex, {
          ...this.actors[this.selectActorIndex],
          staffList: [],
          actorCorpStaffId: "",
          fxCorpId: currentObj.id,
          fxCorpName: currentObj.companyName,
        });
        this.getCompanyStaffList(currentObj.id);
      }
      this.companyListDiaShow = false;
    },
    // 门店商家下拉
    getStoreList() {
      _api.getSelectList().then((res) => {
        if (res.code === 1) {
          this.compydataList = res.data.map((v) => {
            return {
              label: v.name,
              value: v.id,
            };
          });
        }
      });
    },
    searchAuth(index, item) {
      if (!item.certNoForMatch) {
        return this.$message.error("请输入统一社会信用代码");
      }
      if (!item.actorName) {
        return this.$message.error("请输入企业名称");
      }
      let params = {
        corpName: item.actorName,
        corpIdentNo: item.certNoForMatch,
      };
      this.searchAuthBtnLoading = true;
      _http
        .getIdentifiedStatus(params)
        .then((res) => {
          if (res.code === 1) {
            this.$set(this.actors, index, {
              ...this.actors[index],
              identStatus: res.data.identStatus,
            });
          }
        })
        .finally(() => {
          this.searchAuthBtnLoading = false;
        });
    },
    // 确认选择商家
    addMerchantSubmit() {
      if (!this.currentMerchantId) {
        return this.$message.error("请选择回收商家");
      }
      let currentObj = null;
      this.dialogTableData.forEach((item) => {
        if (item.merchantId === this.currentMerchantId) {
          currentObj = item;
        }
      });
      if (
        this.actors[this.selectActorIndex].fxCorpId !== currentObj.merchantId
      ) {
        this.$set(this.actors, this.selectActorIndex, {
          ...this.actors[this.selectActorIndex],
          staffList: [],
          actorCorpStaffId: "",
          fxCorpId: currentObj.merchantId,
          fxCorpName: currentObj.merchantName,
        });
        this.getMerchantStaffList(currentObj.merchantId);
      }
      this.addMerchantDiaShow = false;
    },
    // 获取回收商员工列表
    getMerchantStaffList(merchantId) {
      _api.recycleStaffSelect({ merchantId, type: "01" }).then((res) => {
        this.$set(this.actors, this.selectActorIndex, {
          ...this.actors[this.selectActorIndex],
          staffList: res.data.map((item) => {
            return { id: item.staffId, name: item.staffName,handlerStaffName:item.handlerStaffName };
          }),
        });
      });
    },
    // 获取门店商员工列表
    getCompanyStaffList(companyId) {
      _api.manageStaffSelect({ companyId }).then((res) => {
        this.$set(this.actors, this.selectActorIndex, {
          ...this.actors[this.selectActorIndex],
          staffList: res.data.map((item) => {
            return { id: item.staffId, name: item.staffName,handlerStaffName:item.handlerStaffName };
          }),
        });
      });
    },
    toFillOut() {
      this.controlDiaShow = true;
    },
    // 控件填写完毕
    controlSuccess() {
      this.getTaskinfo();
      this.getFieldRequire();
    },
    handleSignTaskStatus(val) {
      const selectedStatus = this.signTaskStatusOption.find(
        (item) => item.value === val
      );
      return selectedStatus ? selectedStatus.text : "--";
    },
    // 提交签署
    sureSign() {
      this.signDialogShow = true
    },
    signDialogSubmit() {
      this.signDialogBtnLoading = true
      _http.uploadtask({taskId: this.infoId}).then(res => {
        if(res.code === 1){
          console.log(res);
          this.$message.success(res.msg || '操作成功')
          this.getTaskinfo();
          this.signDialogShow = false
        }
      }).finally(() => {
        this.signDialogBtnLoading = false
      })
    }
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.enterpriseStyle {
  color: #666666;
  margin-bottom: 15px;
  font-size: 14px;
  margin-left: 75px;
  > span {
    margin-right: 20px;
  }
  > div {
    margin-right: 10px;
    width: 400px;
  }
}
.feil_cal {
  font-size: 14px;
  height: 30px;
  background: #f5f6fa;
  padding: 0 15px;
  width: 550px;
}
.fieldclass {
  width: 590px;
  margin: 0 0 15px 75px;
}
.top_buutom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  position: relative;
  left: -20px;
  top: -20px;
  width: calc(100% + 40px);
  height: 80px;
  background-color: #ffffff;
}
.top_title_dg {
  display: flex;
  align-items: center;
  padding: 5px 20px;
  position: relative;
  left: -20px;
  top: -20px;
  width: calc(100% + 40px);
  font-size: 14px;
  background: #ffefef;
}
.sigincontentscss {
  margin-bottom: 10px;
  width: 100%;
  border-radius: 10px;
  background-color: #ffffff;
  padding: 20px;
  .sc_hader {
    padding: 0 5px;
    border-left: 4px solid #0981ff;
  }
  .temp_acti {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #606266;
    margin: 15px 0;
  }
}
.sc_centercont {
  font-size: 14px;
  margin: 15px 0;
}
.control_content {
  width: 800px;
  min-height: 92px;
  padding: 16px 0;
  background: #f5f6fa;
  border-radius: 4px;
  margin-bottom: 10px;
  position: relative;
}
.con_ctop {
  padding: 0 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: FZLanTingHei-M-GBK;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
}
.con_center {
  margin-top: 15px;
  padding: 0 30px;
  display: flex;
  align-items: center;
}
.control_num {
  font-family: FZLanTingHei-M-GBK;
  font-weight: 400;
  font-size: 12px;
  color: #f5f6fa;
  width: 22px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  background: #ffaf29;
  border-radius: 1px 8px 8px 1px;
  position: absolute;
  left: 0;
  top: 18px;
}
.StaffManage-list {
  .button_top {
    cursor: pointer;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .faultBtn {
    width: 280px;
    height: 42px;
    background: #f9fbfd;
    border: 1px solid #c1d1ff;
    box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
    border-radius: 21px;
    display: flex;
    .left {
      text-align: center;
      color: white;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 40px;
      height: 40px;
      background: #0981ff;
      border-radius: 20px;
    }
    .right {
      text-align: center;
      color: #333;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 40px;
      height: 40px;
      border-radius: 20px;
    }
  }
}
.dis_al_spbteewn {
  flex-wrap: wrap;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dis_alin_center {
  display: flex;
  align-items: center;
}
.add-company {
  /deep/.el-radio__label {
    display: none;
  }
}
.fa-upload__input {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 97px;
  height: 32px;
  z-index: 100;
  opacity: 0;
}
.text_flow{
  width: 400px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical
}
.stoandmerch{
  border-radius: 20px;
  position: relative;
  right: 60px;
}
</style>
